import {
  AlertsContainer,
  Header,
  VerticalListing,
  useTranslation
} from '@fareye/common'
import { Flex, IRenderControl, RenderControl } from '@fareye/ui'
import { cancelToken, currenthhmmA, isEmpty } from '@fareye/utils'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { IPageConfig } from '../../utility/types'
import { FormRenderer } from './FormRenderer'
import { SubscriptionListing } from './SubscriptionListing'
import { IKeyValueObj } from '@fareye/types'

interface IAlertSettingProps extends RouteComponentProps {
  routesConfig: any
  config: IPageConfig
  baseUrl: string
}

export function AlertSettings({
  match,
  history,
  location,
  routesConfig,
  config: propsConfig,
  baseUrl
}: IAlertSettingProps) {
  const showTimezone = false
  const { t } = useTranslation()
  const { config, styling, children } = propsConfig
  const { bodyBgColor } = styling ? styling : { bodyBgColor: '' }
  const [selectedAlertType, setSelectedAlertType] = React.useState<string>(
    (config
      ? config.selectedAlertType
      : 'DisconnectionAlertSubscription') as string
  )
  const [selectedAlert, setSelectedAlert] = React.useState(null)
  const [editingAlert, setEditingAlert] = React.useState<any>(null)
  const [lastUpdate, setLastUpdate] = React.useState(currenthhmmA())
  const [alertConfig, setAlertConfig] = React.useState<IRenderControl>({
    data: config.alertListing,
    isLoading: false,
    isSuccess: true,
    message: '',
    isError: false
  })
  let tempAlertConfig = alertConfig.data
  let listingOptions: Array<IKeyValueObj<string>> = []
  Object.keys(tempAlertConfig).map((ele: string) => {
    listingOptions.push({
      label: tempAlertConfig[ele].formBuilderConfig.label,
      value: ele,
      type: tempAlertConfig[ele].type ? tempAlertConfig[ele].type : 'road'
    })
  })

  return (
    <Flex column width={1} style={{ height: '100%' }}>
      <Header
        lastUpdate={lastUpdate}
        match={match}
        location={location}
        history={history}
        routesConfig={routesConfig}
        showTimezone={showTimezone}
      />
      <div style={{ flexGrow: 1, background: bodyBgColor, overflow: 'hidden' }}>
        <RenderControl state={alertConfig} variant="l" t={t}>
          <AlertsContainer>
            {!isEmpty(alertConfig.data) && (
              <>
                <VerticalListing
                  listingOptions={listingOptions}
                  setSelected={setSelectedAlertType}
                  selected={selectedAlertType}
                />
                <Flex column style={{ overflow: 'auto' }}>
                  <FormRenderer
                    selectedAlertType={selectedAlertType}
                    formRenderingConfig={
                      alertConfig.data[selectedAlertType].formBuilderConfig
                    }
                    selectedAlert={selectedAlert}
                    setSelectedAlert={setSelectedAlert}
                    editingAlert={editingAlert}
                    setEditingAlert={setEditingAlert}
                    propsConfig={children['addAlert']}
                    baseUrl={baseUrl}
                  />
                  <SubscriptionListing
                    subscriptionType={selectedAlertType}
                    selectedAlert={selectedAlert}
                    setSelectedAlert={setSelectedAlert}
                    editingAlert={editingAlert}
                    setEditingAlert={setEditingAlert}
                    alertChildrenConfig={children}
                    isReload={true}
                    selectAlertLabel={
                      alertConfig.data[selectedAlertType].formBuilderConfig
                        .label
                    }
                  />
                </Flex>
              </>
            )}
          </AlertsContainer>
        </RenderControl>
      </div>
    </Flex>
  )
}
